/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   url utilites constants
 */

import { PropertyFeatures } from '@zcode/enums'

// regex
export const BEDROOMS_RE = /(\d[+-])beds?|((?:(?:studios?|\d),){1,4}\d[+-])beds?/
export const FILTERS_START_RE =
  /\/(?:no-fee|low-income|no-security-deposit|move-in-special|utilities-included|pet-friendly|dog-friendly|cat-friendly|on-site-laundry|over-\d+|under-\d+|price[-,:]?[\d,]+(?:[,-][\d,]+?)?|nightly-over-\d+|nightly-under-\d+|nightly-price[-,:]?[\d,]+(?:[,-][\d,]+?)?|studios?\+?|\d[+-]beds?|(?:(?:studios?|\d),){1,4}\d[+-]beds?)(?:\/|\?|$)/

export const LUXURY_RE = /cheap|luxury/
export const BATHROOMS_RE = /bathrooms/
export const OVER_RE = /over-(\d+)/
export const PRICE_RANGE_RE = /price[-,:]?([,\d]+)(?:[,-]([\d,]+))?/
export const STUDIO_RE = /studios?(\+)?(?![-,+s\d])/
export const UNDER_RE = /under-(\d+)/
export const FIXED_ID_RE = /fixedId=[lb]\d+/
export const NIGHTLY_UNDER_RE = /nightly-under-(\d+)/
export const NIGHTLY_OVER_RE = /nightly-over-(\d+)/
export const NIGHTLY_PRICE_RANGE_RE = /nightly-price[-,:]?([,\d]+)(?:[,-]([\d,]+))?/
// end of regex

export const orFeatureVerticals = new Set([
  PropertyFeatures.SPECIALS,
  PropertyFeatures.UTILITIES_INCLUDED,
  PropertyFeatures.NO_SECURITY_DEPOSIT,
])
